/**
 * StatusBadge
 * Status pill component with colour coding per status value.
 */
import React from 'react';
import PropTypes from 'prop-types';

const STATUS_STYLES = {
  active: { bg: '#dcfce7', color: '#166534', label: 'Active' },
  submitted: { bg: '#dbeafe', color: '#1e40af', label: 'Submitted' },
  contacted: { bg: '#fef3c7', color: '#92400e', label: 'Contacted' },
  converted: { bg: '#dcfce7', color: '#166534', label: 'Converted' },
  closed: { bg: '#f1f5f9', color: '#475569', label: 'Closed' },
  pending: { bg: '#fef3c7', color: '#92400e', label: 'Pending' },
  cancelled: { bg: '#fef2f2', color: '#991b1b', label: 'Cancelled' },
  expired: { bg: '#f1f5f9', color: '#475569', label: 'Expired' },
  paid: { bg: '#dcfce7', color: '#166534', label: 'Paid' },
  overdue: { bg: '#fef2f2', color: '#991b1b', label: 'Overdue' },
  draft: { bg: '#f1f5f9', color: '#475569', label: 'Draft' },
  live: { bg: '#dcfce7', color: '#166534', label: 'Live' },
  paused: { bg: '#fef3c7', color: '#92400e', label: 'Paused' },
  trialing: { bg: '#ede9fe', color: '#5b21b6', label: 'Trialing' },
  free: { bg: '#f1f5f9', color: '#475569', label: 'Free' },
  pro: { bg: '#dbeafe', color: '#1e40af', label: 'Pro' },
  enterprise: { bg: '#ede9fe', color: '#5b21b6', label: 'Enterprise' },
};

export default function StatusBadge({ status, customLabel }) {
  const key = status?.toLowerCase() || 'pending';
  const style = STATUS_STYLES[key] || { bg: '#f1f5f9', color: '#475569', label: status || 'Unknown' };

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 10px',
        fontSize: '12px',
        fontWeight: '600',
        borderRadius: '9999px',
        backgroundColor: style.bg,
        color: style.color,
        whiteSpace: 'nowrap',
        lineHeight: '1.4',
      }}
    >
      {customLabel || style.label}
    </span>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  customLabel: PropTypes.string,
};

StatusBadge.defaultProps = {
  customLabel: null,
};
